<template>
  <div>
    <h2 class="popup-message-title">{{ $t('participation.missing_access_code.title') }}</h2>
    <h3>{{ title }}</h3>
    <p>{{ hint }}</p>
    <form class="basicForm">
      <div class="form-row">
        <div class="form-item form-item-40">
          <label>{{ $t('participation.missing_access_code.fld_code_label') }} *</label>
          <input name="code" type="text" class="form-check-input" v-model="code" required/>
        </div>
      </div>

      <div id="submitOrBusy" class="form-submit">
        <button class="btn btn-amber mb-2" v-if="axiosBusy" disabled>
          <span class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true" />{{ $t('form.generic.btn_spinner') }}</button>
        <button class="btn btn-red mb-2" v-else-if="!code" disabled>
          {{ $t('form.generic.btn_form_invalid') }}
        </button>
        <button class="btn btn-green mb-2" v-else
          v-on:click.prevent="provideCode()" >{{ $t('form.generic.btn_save') }}</button>
      </div>

      <div v-if="error" class="alert alert-danger" role="alert">
        {{ error }}
      </div>
    </form>
  </div>
</template>

<script>
import {
  getAccessCodeSetInfo,
  provideAccessCode
} from "@/api/access_code.js";
import { mapGetters } from "vuex";

export default {
  name: 'AccessCode',
  props: ['campaign', 'missingAccessCodeSets'],
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    })
  },
  data() {
    return {
      code: null,
      error: null,
      title: this.$t('participation.missing_access_code.title'),
      hint: this.$t('participation.missing_access_code.hint')
    };
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const rv = await getAccessCodeSetInfo(this.$userClient, this.missingAccessCodeSets[0]);
      if (rv) {
        this.title = rv.hint_title;
        this.hint = rv.hint_text;
      }
    },
    async provideCode() {
      const rv = await provideAccessCode(this.$userClient, {
        code: this.code,
        access_code_sets: this.missingAccessCodeSets,
        is_participation: true,
        campaign: this.campaign
      });
      if (rv.status === 'code-accepted') {
        this.$emit('access-code-provided');
      }
      else {
        this.error = this.$t('participation.missing_access_code.err_' + rv.status, { code: this.code });
      }
    }
  }
}
</script>
